module.exports = __webpack_public_path__ + "img/right_4.140c0dd5.jpg";